import Box from "@mui/material/Box";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import Typography from "@mui/material/Typography";

/**
 * Renders a titled list of items for filter tooltips.
 * Pure function - no React component overhead.
 */
export function renderFilterDetailList(title: string, items: string[]) {
  if (!items?.length) return null;

  return (
    <Box sx={{ mb: 1.5 }}>
      <Typography
        variant="subtitle2"
        sx={{ fontWeight: 500, color: "#424242", mb: 0.5 }}
      >
        {title}
      </Typography>
      <List dense disablePadding>
        {items.map((item, idx) => (
          <ListItem key={idx} sx={{ py: 0.25, px: 0 }}>
            <Typography variant="body2" sx={{ fontSize: 12, color: "#666" }}>
              {item}
            </Typography>
          </ListItem>
        ))}
      </List>
    </Box>
  );
}
